import { render, staticRenderFns } from "./AddOrEditBranchForm.vue?vue&type=template&id=25fc97a8"
import script from "./AddOrEditBranchForm.vue?vue&type=script&lang=ts"
export * from "./AddOrEditBranchForm.vue?vue&type=script&lang=ts"
import style0 from "./AddOrEditBranchForm.vue?vue&type=style&index=0&id=25fc97a8&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports